import { render, staticRenderFns } from "./ProductSwitcher.vue?vue&type=template&id=201f99b4&scoped=true"
import script from "./ProductSwitcher.vue?vue&type=script&lang=js"
export * from "./ProductSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ProductSwitcher.vue?vue&type=style&index=0&id=201f99b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f99b4",
  null
  
)

export default component.exports